import { AbstractControl, ValidatorFn, Validators } from "@angular/forms";

export interface ValidationResult {
    [key: string]: boolean;
}

export class ValidationHelper {
    public static createError(name: string): ValidationResult {
        return { [name]: true };
    }
}

export interface ReferenceControlAndValues<T> {
    referenceControl: AbstractControl;
    comparableValue: T[] | boolean
}
export class CustomValidators {
    /**
    * Validate if control is required  by comparing another control
    */
    public static otherControlsRequired<T>(referenceControls: ReferenceControlAndValues<T>[]): ValidatorFn {
        return (control: AbstractControl) => {
            const validation: boolean = referenceControls.every((r) => {
                let compare = typeof r.comparableValue === 'boolean' ? r.comparableValue === r.referenceControl.value : r.comparableValue.find((v) => v === r.referenceControl.value)
                return !r.referenceControl.invalid && compare;
            });
            return validation ? Validators.required(control) : null;
        };
    }


    public static hasUpperCase(): ValidatorFn {
        return (control: AbstractControl): ValidationResult | null => {
            if (/[A-Z]/.test(control.value))
                return null;

            return ValidationHelper.createError('notUpper');
        };
    }

    public static hasNumber(): ValidatorFn {
        return (control: AbstractControl): ValidationResult | null => {
            if (/\d/.test(control.value))
                return null;

            return ValidationHelper.createError('notNumber');
        };
    }

    public static isValueInRange(minLength: number, maxLength: number): ValidatorFn {
        return (control: AbstractControl): ValidationResult | null => {
            if (control.value?.length >= minLength && control.value?.length <= maxLength)
                return null;

            return ValidationHelper.createError('notValueInRange');
        };
    }


    public static notWhiteSpaces(): ValidatorFn {
        return (control: AbstractControl): ValidationResult | null => {
            if (/\s/.test(control.value))
                return ValidationHelper.createError('notWhiteSpaces');

            return null;
        };
    }

    public static compareValues(leftControl: string, rightControl: string): ValidatorFn {
        return (control: AbstractControl): ValidationResult | null => {
            if (control.get(leftControl)?.value != control.get(rightControl)?.value)
                return ValidationHelper.createError('notEqual');

            return null;
        };
    }
}